import { createContext, useContext } from 'react';
import { EnqueueVideoGenerationNotificationArgs, EnqueueVideoNotificationArgs, VideoNotificationItem } from './types';

export interface VideoNotificationsContextValue {
  items: VideoNotificationItem[];
  visibleItems: VideoNotificationItem[];
  unreadCount: number;
  enqueuePending: (args: EnqueueVideoNotificationArgs) => void;
  enqueuePendingVideoGeneration: (args: EnqueueVideoGenerationNotificationArgs) => void;
  markAsRead: (id: string) => void;
  dismissNotification: (id: string) => void;
}

export const VideoNotificationsContext = createContext<VideoNotificationsContextValue | null>(null);

export function useVideoNotifications(): VideoNotificationsContextValue {
  const context = useContext(VideoNotificationsContext);

  if (!context) {
    throw new Error('useVideoNotifications must be used within VideoNotificationsProvider');
  }

  return context;
}
